export default () => {
    return [{
        key: '0',
        title: '项目',
        icon: 'project',
        sub: [{
            key: '0-0',
            title: '概览',
            link: 'dashboard',
            active: ['dashboard']
        }, {
            key: '0-1',
            title: '我的项目',
            link: 'myProject',
            active: ['myProject']
        }, {
            key: '0-2',
            title: '归档的项目',
            link: 'completeProject',
            active: ['completeProject']
        }]
    }, {
        key: '1',
        title: '任务',
        icon: 'task',
        sub: [{
            key: '1-0',
            title: '项目任务',
            link: 'projectTask',
            active: ['projectTask']
        }, {
            key: '1-1',
            title: '我的任务',
            link: 'myTask',
            active: ['myTask']
        }]
    }, {
        key: '2',
        title: '设置',
        icon: 'setting',
        sub: [{
            key: '2-0',
            title: '任务类型',
            link: 'taskType',
            active: ['taskType']
        },
            // {
            //     key: '2-1',
            //     title: '邮件提醒',
            //     // link: 'mailWarn',
            //     active: ['mailWarn']
            // }, {
            //     key: '2-2',
            //     title: '定期报告',
            //     // link: 'report',
            //     active: ['report']
            // }
        ]
    }]
};
